export enum EditProductOfferingStep {
  OFFERING_DETAILS = "offeringDetails",
  PLAN_PACKAGE = "planPackage",
  DESIGN_PACKAGES = "designPackages",
  OPTIONS = "options",
  REVIEW = "review",
}
